import { defineMessages } from "react-intl";
import { Brand } from "../../contract/pam.js";
import { LicenseType } from "./types.js";
const LicenseTypeTypeName = "LicenseType";
const ServerLicenseTypeTypeName = "ServerLicenseType";
const licenseLocalized = defineMessages({
  CURACAO: {
    id: "License_Server_CURACAO",
    defaultMessage: "Curacao"
  },
  TOBIQUE: {
    id: "License_Server_TOBIQUE",
    defaultMessage: "Tobique"
  },
  SOUTHKOREA: {
    id: "License_Server_SOUTHKOREA",
    defaultMessage: "South Korea"
  },
  PHILIPPINES: {
    id: "License_Server_PHILIPPINES",
    defaultMessage: "Philippines"
  },
  CHINA: {
    id: "License_Server_CHINA",
    defaultMessage: "China"
  },
  ANJOUAN: {
    id: "License_Server_ANJOUAN",
    defaultMessage: "Anjouan"
  },
  CIS: {
    id: "License_Server_CIS",
    defaultMessage: "CIS"
  }
});
const licenseOptions = [
  { value: LicenseType.CURACAO, label: licenseLocalized.CURACAO },
  { value: LicenseType.KR, label: licenseLocalized.SOUTHKOREA },
  { value: LicenseType.PH, label: licenseLocalized.PHILIPPINES },
  { value: LicenseType.TOBIQUE, label: licenseLocalized.TOBIQUE },
  { value: LicenseType.CHINA, label: licenseLocalized.CHINA },
  { value: LicenseType.ANJOUAN, label: licenseLocalized.ANJOUAN },
  { value: LicenseType.CIS, label: licenseLocalized.CIS }
];
const serverLicenseOptions = [
  { value: "CURACAO", label: licenseLocalized.CURACAO },
  { value: "TOBIQUE", label: licenseLocalized.TOBIQUE },
  { value: "SOUTHKOREA", label: licenseLocalized.SOUTHKOREA },
  { value: "PHILIPPINES", label: licenseLocalized.PHILIPPINES },
  { value: "CHINA", label: licenseLocalized.CHINA },
  { value: "ANJOUAN", label: licenseLocalized.ANJOUAN },
  { value: "CIS", label: licenseLocalized.CIS }
];
const serverLicenses = ["CURACAO", "TOBIQUE", "PHILIPPINES", "SOUTHKOREA", "CHINA", "ANJOUAN", "CIS"];
const localizedBrand = defineMessages({
  AKSPOKER: {
    id: "BrandCircle_AKSPOKER",
    defaultMessage: "AKs Poker"
  },
  NEXAPOKER: {
    id: "BrandCircle_NEXAPOKER",
    defaultMessage: "Nexa Poker"
  },
  UNKNOWN: {
    id: "BrandCircle_UNKNOWN",
    defaultMessage: "Unknown"
  },
  WPTG: {
    id: "BrandCircle_WPTG",
    defaultMessage: "WPTG"
  },
  WPTGO: {
    id: "BrandCircle_WPTGO",
    defaultMessage: "WPTGO"
  },
  WPTGPUKE: {
    id: "BrandCircle_WPTGPUKE",
    defaultMessage: "WPTG Puke"
  }
});
const brandOptions = [
  { value: Brand.Akspoker, label: localizedBrand.AKSPOKER },
  { value: Brand.Nexapoker, label: localizedBrand.NEXAPOKER },
  { value: Brand.Unknown, label: localizedBrand.UNKNOWN },
  { value: Brand.Wptg, label: localizedBrand.WPTG },
  { value: Brand.Wptgo, label: localizedBrand.WPTGO },
  { value: Brand.Wptgpuke, label: localizedBrand.WPTGPUKE }
];
export {
  LicenseTypeTypeName,
  ServerLicenseTypeTypeName,
  brandOptions,
  licenseLocalized,
  licenseOptions,
  localizedBrand,
  serverLicenseOptions,
  serverLicenses
};
//# sourceMappingURL=constants.js.map
